import globals from '../../globals';
import actionTypes from '../constants/action-types';
import DEFAULT_OPTIONS from '../constants/default-options';
import { UPDATE_LIVE_ONLY } from '../../hdrm/constants/update-strategies';

const bulkSetChildrenPresence = (
  containerId,
  childrenPresenceUpdates,
  options = DEFAULT_OPTIONS
) => {
  const action = {
    type: actionTypes.BULK_SET_CHILDREN_PRESENCE,
    payload: {
      containerId,
      childrenPresenceUpdates,
      options,
    },
  };

  return options.strategy === UPDATE_LIVE_ONLY
    ? action
    : globals.helpers.globalActionExtender(action);
};

export default bulkSetChildrenPresence;
